import * as Sentry from '@sentry/nextjs';
import { isEqual } from 'lodash';

import NAMES from '~/constants/NAMES';
import { DeviceCheckResult } from '~/generated/graphql';
import fetchFromElectron from '~/helpers/deviceChecks/fetchFromElectron';
import { DeviceCheckMetadata } from '~/types';

const checkOpenApps: DeviceCheckMetadata['check'] = async ({
  registrationDetails,
}) => {
  let openApps: string[] = [];

  try {
    const promise = window.electron && fetchFromElectron('OPEN_APPS');
    const result = await promise;
    const actGateway = `${NAMES.APP.toLowerCase()}`;
    openApps = result?.data?.apps.filter(app => app !== actGateway) ?? [];
    const allowedApps = [actGateway];

    if ((openApps && openApps.length === 0) || isEqual(openApps, allowedApps)) {
      return {
        result: DeviceCheckResult.Pass,
        value: openApps.toString(),
      };
    }
    throw new Error('Check failed');
  } catch (err) {
    const error = new Error(
      JSON.stringify({
        error: String(err),
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    return {
      result: DeviceCheckResult.Pass,
      value: openApps.toString(),
    };
  }
};

export default checkOpenApps;
